import { _ } from "../../core/polyglot/polyglot.js";
import { lockIcon } from "../../core/elements/icons/index.js";
import externalDocument from "../shared/externalDocument.js";
import jQuery from "jquery";
import OldSpinnerWidget from "../../deprecated/OldSpinnerWidget/OldSpinnerWidget.js"; // eslint-disable-line import-x/no-deprecated -- todo: migrate to new spinner
import session from "../../core/session.js";
import userService from "../../core/services/userService.js";

const configuration = {
	popupEnabled: undefined,
};

/**
 * Configuration for `migrateDocument`.
 *
 * @param {bool|undefined} [popupEnabled] - Indicates whether to show the migration help popup when clicking
 * the submit button. If left `undefined`, the popup will appear only
 * if AAA is active.
 */
export function setConfiguration({ popupEnabled } = {}) {
	configuration.popupEnabled = popupEnabled;
}

/**
 *    `migrateDocument' manages the log in process.
 *    It basically builds a form (see `userLoginForm`) to collect
 *    the user name and password, and send them to the server
 *
 *    POST: /External/Authenticate/Login
 */

/**
 * Todo: Add JSDoc comment
 */
function migrateDocument(spec, my) {
	spec ||= {};
	my ||= {};

	const that = externalDocument(spec, my);

	that.documentId = "login-document";

	that.title = _("Migrate your existing account");

	let username = session.getCurrentUser().getId();
	let password = "";

	// eslint-disable-next-line import-x/no-deprecated -- todo: migrate to new spinner
	my.loadingSpinner = new OldSpinnerWidget({
		imagePath: "/client/img/loading-spin.svg",
		size: 24,
		visible: false,
	});

	my.showMigrationHelpThenLogin = function () {
		if (!my.shouldShowPopup()) {
			my.login();
			return;
		}

		my.confirm({
			cssClass: "migration-dialog",
			title: (html) => {
				html.span(_("A better, more secure way to login"));
				html.i({ klass: "far fa-thumbs-up" });
			},
			body: my.migrationHelpRenderer(),
			confirmLabel: _("Start migrating to Wolters Kluwer"),
			callback: () => my.login(),
		});
	};

	my.migrationHelpRenderer = function () {
		return (html) => {
			my.renderWKHeroOn(html);

			html.div(
				{ klass: "migration-step" },
				html.div(
					{ klass: "migration-step-content" },
					html.div(
						{ klass: "text" },
						_(
							"You need to migrate your finsit account to Wolters Kluwer.",
						),
						html.br(),
						_(
							"Click on the blue button below to start the process.",
						),
					),
				),
			);
		};
	};

	my.login = function () {
		my.clearErrors();

		const button = jQuery("#login-button");
		button.attr({ disabled: "disabled" });
		my.loadingSpinner.show();

		userService.login({
			username,
			password,
			onError,
			onSuccess,
		});
	};

	my.clearErrors = function () {
		const errorsDiv = jQuery("#errors");
		errorsDiv.removeClass();
		errorsDiv.empty();
	};

	my.setLocation = function (location) {
		my.redirectToLocationPath(location);
	};

	that.renderContentOn = function (html) {
		html.div(
			{ klass: "login" },
			html.div(
				{ klass: "row" },
				html.h1(lockIcon, that.title),
				my.renderFTGPLoginPanelOn,
				my.renderWKHeroOn,
			),
		);
	};

	my.renderFTGPLoginPanelOn = function (html) {
		html.div(
			{ klass: "alert alert-warning" },
			html.h4(_("New authentication method required")),
			html.p(_("Log in here to start your migration process.")),
		);

		html.div(
			{ klass: "panel login-panel" },
			html.div(
				{ klass: "panel-body" },
				html
					.form(
						{ id: "login-form", name: "loginform" },
						renderUsernameOn,
						renderPasswordOn,
						renderErrorsOn,
						html.div({ class: "row" }, renderExternalLinksOn),
						renderLoginOn,
					)
					.submit((event) => {
						event.preventDefault();
						submitLogin();
					}),
			),
		);
	};

	my.renderWKHeroOn = function (html) {
		html.div(
			{ klass: "wk-hero" },
			html.h2(_("Improved authentication")),
			html.div(
				{ klass: "row" },
				html.div(
					{ klass: "wk-hero-item" },
					html.span(lockIcon),
					html.h3(_("Improved security")),
				),
				html.div(
					{ klass: "wk-hero-item" },
					html.span(html.i({ klass: "far fa-credit-card" })),
					html.h3(_("BankID support")),
				),
				html.div(
					{ klass: "wk-hero-item" },
					html.span(html.i({ klass: "fa fa-user" })),
					html.h3(_("One account for all services")),
				),
			),
		);
	};

	function renderPasswordOn(html) {
		html.div(
			{ class: "form-group" },
			html.input({
				id: "password",
				name: "password",
				type: "password",
				class: "form-control input-lg",
				placeholder: _("Finsit Password"),
			}),
		);
	}

	function renderUsernameOn(html) {
		html.div(
			{ class: "form-group" },
			html.input({
				id: "username",
				autocapitalize: "off",
				name: "username",
				type: "text",
				class: "form-control input-lg",
				placeholder: _("Finsit Username"),
			}),
		);
	}

	function renderExternalLinksOn(html) {
		html.div(
			{ class: "form-group col-xs-12 text-right" },
			html.div(
				{ class: "external-link" },
				html.a(
					{ href: my.linkTo("recover", {}), "data-test": "recover" },
					_("Forgot password?"),
				),
			),
			html.div(
				{ class: "external-link" },
				html.a(
					{
						href: userService.getWKLoginUrl(),
						"data-test": "wk-login",
					},
					_("Already migrated? Sign in with Wolters Kluwer"),
				),
			),
		);
	}

	function renderLoginOn(html) {
		html.div(
			{ class: "row" },
			html.div(
				{ class: "col-sm-12 text-center" },
				html.div(
					{ class: "form-group nopadding nomargin" },
					html.button(
						{
							type: "submit",
							"data-test": "login",
							id: "login-button",
							klass: "login-button btn btn-block btn-lg btn-success",
						},
						my.loadingSpinner,
						_("Start migration"),
					),
				),
			),
		);
	}

	function renderErrorsOn(html) {
		html.div(
			{ class: "row" },
			html.div(
				{ class: "col-sm-12 text-center" },
				html.div({ id: "errors" }),
			),
		);
	}

	my.didAttach = function () {
		that.asJQuery().find(":text").focus();
	};

	my.shouldShowPopup = function () {
		const popupEnabled = configuration.popupEnabled;

		if (popupEnabled === undefined) {
			return session.wkIdEnabled;
		}
		return popupEnabled;
	};

	my.getErrorMessage = function (errorResponse) {
		const errorMessage = errorResponse?.responseJSON?.message;

		switch (errorMessage) {
			case "can not find the anti forgery token": {
				return _("Cannot find the anti-forgery token");
			}
			case "Unauthenticated request.": {
				return _("Invalid username or password.");
			}

			default: {
				return _("An unknown error '{unknownError}' was received", {
					unknownError: errorMessage,
				});
			}
		}
	};

	function submitLogin() {
		username = jQuery("#username").val();
		password = jQuery("#password").val();
		my.showMigrationHelpThenLogin();
	}

	function onSuccess() {
		const returnUrl = getReturnUrl();
		if (returnUrl) {
			my.setLocation(decodeURIComponent(returnUrl));
		} else {
			my.setLocation("/Navigate/ToService");
		}
	}

	function getReturnUrl() {
		return my.router.getParameter("ReturnUrl");
	}

	function onError(errorResponse) {
		const errorMessage = my.getErrorMessage(errorResponse);
		const errorsDiv = jQuery("#errors");
		const button = jQuery("#login-button");
		errorsDiv.append(errorMessage.toString());
		errorsDiv.addClass("alert alert-danger");
		button.removeAttr("disabled");
		my.loadingSpinner.hide();
	}

	return that;
}

export default migrateDocument;
